import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddEstimateLoader from './AddEstimateLoader';
import addDesign from '../actions/addDesign';

const mapDispatchToProps = dispatch => bindActionCreators({
  addDesign,
}, dispatch);

export default connect(null, mapDispatchToProps)(AddEstimateLoader);
